import { Component } from '@angular/core';
import { CourseContentDisplayComponent } from '../course-content-display/course-content-display.component';
import { UserCourseDataService } from 'lms-api';

@Component({
  selector: 'app-course-content-display-pdf',
  templateUrl: './course-content-display-pdf.component.html',
  styleUrls: ['./course-content-display-pdf.component.scss']
})
export class CourseContentDisplayPDFComponent extends CourseContentDisplayComponent {
  constructor(
    ucdService: UserCourseDataService
  ) {
    super(ucdService);
  }

  ngOnInit() {
  }
}
